import { render, staticRenderFns } from "./SearchUserProfit.vue?vue&type=template&id=48db5559&scoped=true"
import script from "./SearchUserProfit.vue?vue&type=script&lang=js"
export * from "./SearchUserProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db5559",
  null
  
)

export default component.exports